<template>
  <div class="home-container">
   <img @click="$router.push('/activity')" src="https://s.cd5i.com/vote/activity/cdch.jpeg" alt="">
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      info: {}
    }
  },
  components: {
  },
  methods: {
    // 获取文章详情
    getArticleDetail(voteId){
      this.$api.activity.getArticleDetail(this.$route.query.id, {},res=>{
        this.info = res.data
      })
    },
  },
  mounted(){
    
  },
}
</script>

<style lang="scss" scoped>
.home-container{
 img {
   width: 100%;
   height: auto
 }
}
</style>
